
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { FlatTourData } from '@/utils/tourTransformUtils';

interface TourDetailHeaderProps {
  tour: FlatTourData;
}

export const TourDetailHeader: React.FC<TourDetailHeaderProps> = ({ tour }) => {
  const { language } = useLanguage();
  return (
    <div className="mb-8">
      {/* Tour Cover Image */}
      {tour.cover_image && (
        <div className="w-full h-64 mb-6 overflow-hidden rounded-xl">
          <img 
            src={tour.cover_image} 
            alt={tour.title}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      
      {/* Tour Title and Metadata */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold mb-2">{tour.title}</h1>
        {tour.description && (
          <p className="text-gray-600 text-lg">{tour.description}</p>
        )}
        
      </div>
    </div>
  );
};
